import { inject, Injectable, signal } from '@angular/core';
import { SupabaseService } from '../auth/supabase.service';

@Injectable({ providedIn: 'root' })
export class PermissionsService {
  private readonly supabase = inject(SupabaseService).client;

  private readonly _permissions = signal<ReadonlySet<string>>(new Set());
  readonly permissions = this._permissions.asReadonly();

  async refresh(): Promise<void> {
    const { data, error } = await this.supabase.schema('crm').rpc('my_permissions');

    if (error || !data) {
      this._permissions.set(new Set());
      return;
    }

    this._permissions.set(new Set(data as string[]));
  }

  can(key: string): boolean {
    return this._permissions().has(key);
  }

  /** True if the user holds at least one CRM permission (i.e. has a role granting access). */
  hasAnyPermission(): boolean {
    return this._permissions().size > 0;
  }

  clear(): void {
    this._permissions.set(new Set());
  }
}
